import { type FirebaseApp, getApps, initializeApp } from 'firebase/app'
import { type Auth, browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth'

import { getAppConfig, isFirebaseConfigured } from '@/shared/config/runtime-config'

/**
 * Firebase se inicializa PEREZOSAMENTE.
 *
 * La config llega en runtime (`/config.js`), asi que al momento en que se
 * evalua este modulo puede no existir todavia. Inicializar al importar tambien
 * rompe los tests, que no tienen proyecto de Firebase.
 */

let app: FirebaseApp | null = null
let auth: Auth | null = null

export function getFirebaseApp(): FirebaseApp | null {
  if (!isFirebaseConfigured()) return null
  if (app) return app

  const { firebase } = getAppConfig()
  app = getApps()[0] ?? initializeApp(firebase)
  return app
}

export function getFirebaseAuth(): Auth | null {
  if (auth) return auth

  const firebaseApp = getFirebaseApp()
  if (!firebaseApp) return null

  auth = getAuth(firebaseApp)
  // Persistencia local: el ID token se refresca solo y la sesion sobrevive al
  // reload. Nada de esto toca la cache de React Query, que nunca va a disco.
  void setPersistence(auth, browserLocalPersistence).catch(() => {
    /* modo incognito con storage bloqueado: seguimos en memoria */
  })

  return auth
}

/** Solo para tests. */
export function resetFirebase(): void {
  app = null
  auth = null
}
